export default function useCurrency() {
  const { n } = useI18n()

  const businessStore = useBusinessStore()

  const formatCurrency = (
    rawPrice: number,
    currency?: Currency,
    currencyDisplay?: 'symbol' | 'code' | 'name'
  ): string => {
    return n(rawPrice, {
      currency: currency ?? businessStore.billing.currency ?? 'EUR',
      style: 'currency',
      currencyDisplay: currencyDisplay ?? 'code',
      maximumFractionDigits: rawPrice % 1 === 0 ? 0 : 2,
    })
  }

  return {
    formatCurrency,
  }
}
